// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_common_image_view_options.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { BoolValue, DoubleValue, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.diagnocat.model.MedicalImageViewOptions
 */
export const MedicalImageViewOptions = proto3.makeMessageType(
  "com.diagnocat.model.MedicalImageViewOptions",
  () => [
    { no: 1, name: "WindowWidth", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 2, name: "WindowLevel", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 3, name: "Sharpness", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 4, name: "Invert", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "ViewportCoords", kind: "message", T: MedicalImageViewportCoords, opt: true },
    { no: 11, name: "Brightness", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 12, name: "Contrast", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 20, name: "Rotation", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 21, name: "FlipHorizontal", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 22, name: "CropBox", kind: "message", T: CropBox, opt: true },
    { no: 23, name: "Zoom", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 24, name: "PanX", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 25, name: "PanY", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.MedicalImageViewportCoords
 */
export const MedicalImageViewportCoords = proto3.makeMessageType(
  "com.diagnocat.model.MedicalImageViewportCoords",
  () => [
    { no: 1, name: "Left", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 2, name: "Top", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 3, name: "Right", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 4, name: "Bottom", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.CropBox
 */
export const CropBox = proto3.makeMessageType(
  "com.diagnocat.model.CropBox",
  () => [
    { no: 1, name: "X", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "Y", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "Width", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "Height", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.MedicalImageViewOptions_Legacy
 */
export const MedicalImageViewOptions_Legacy = proto3.makeMessageType(
  "com.diagnocat.model.MedicalImageViewOptions_Legacy",
  () => [
    { no: 1, name: "WindowWidth", kind: "message", T: DoubleValue },
    { no: 2, name: "WindowLevel", kind: "message", T: DoubleValue },
    { no: 3, name: "Sharpness", kind: "message", T: DoubleValue },
    { no: 4, name: "Invert", kind: "message", T: BoolValue },
    { no: 5, name: "ColorMap", kind: "message", T: MedicalImageColorMap_Legacy },
    { no: 6, name: "ViewportCoords", kind: "message", T: MedicalImageViewportCoords_Legacy },
    { no: 11, name: "Brightness", kind: "message", T: DoubleValue },
    { no: 12, name: "Contrast", kind: "message", T: DoubleValue },
  ],
);

/**
 * @generated from message com.diagnocat.model.MedicalImageViewportCoords_Legacy
 */
export const MedicalImageViewportCoords_Legacy = proto3.makeMessageType(
  "com.diagnocat.model.MedicalImageViewportCoords_Legacy",
  () => [
    { no: 1, name: "Left", kind: "message", T: DoubleValue },
    { no: 2, name: "Top", kind: "message", T: DoubleValue },
    { no: 3, name: "Right", kind: "message", T: DoubleValue },
    { no: 4, name: "Bottom", kind: "message", T: DoubleValue },
  ],
);

/**
 * @generated from message com.diagnocat.model.MedicalImageColorMap_Legacy
 */
export const MedicalImageColorMap_Legacy = proto3.makeMessageType(
  "com.diagnocat.model.MedicalImageColorMap_Legacy",
  [],
);

